import React, { useEffect, useState, useContext } from 'react';
import { AppContext } from "Context/AppContext";
import {
    BOOLEAN,
    COLLAPSE_ALL,
    DATA_MODEL, DECIMAL,
    EXCLUSION_DEFAULT,
    EXPAND_ALL, FIELD, FRACTION,
    INCLUSION_DEFAULT, INTEGER, MULTI_CHOICE,
    MULTI_CHOICE_EXCLUDED_DEFAULT, RANGE_FIELD, TEXT_FIELD,
} from '../../ISRConstants';
import searchIcon from "../../../../../assests/img/search-icon.svg";
import {TField as ModelTField, TUpsertISRProjectDataModelsInput} from '../DefineModel/model';
import WorkSpace from './Components/WorkSpace';
import SubmodleFieldItem from './Components/SubmodleFieldItem';
import PageItem from './Components/PageItem';
import AddButton from './Components/AddButton';
import SubModelItem from './Components/SubModelItem';
import {TUIBuilder, TField, TCategory} from './ui';
import { Draggable, DragDropContext, Droppable } from "react-beautiful-dnd";
import BuilderConfig from './Components/BuilderConfig';
import { toast } from 'react-toastify';
import EditField from './Components/EditField';
import EditSubmodel from './Components/EditSubModel';
import EditPage from './Components/EditPage';
import EditCategory from './Components/EditCategory';
import {ISRContext} from "../../Context/ISRContext";
import WidgetSection from './Components/WidgetSection';
import EditCategoryImageDialog from "./Components/EditCategoryImageDialog";
import PopUp from "../../UI-Model/components/PopUp/PopUp";
import AddAttributesPopup from "../../UI-Model/components/PopUp/AddAttributesPopup";
import {getProductsByCategory} from "../../UI-Model/services/ApiHelper";
import {SortableAttribute} from "../../UI-Model/types/sortconfig.types";


type TUIBuilderProps = {
    id: string;
    userProjectDataModels: TUpsertISRProjectDataModelsInput;
    builderData: any;
    uiModelProjectData: any;
    projectId: string;
    modelId: string;
    setUiModelProjectData: React.Dispatch<React.SetStateAction<TUIBuilder>>;
    isPreviewAvailable: boolean;
}

const UIBuilder = ({id, userProjectDataModels, builderData, uiModelProjectData, projectId, modelId, setUiModelProjectData, isPreviewAvailable}: TUIBuilderProps) => {
    const [activeTabIndex, setActiveTabIndex] = useState<number>(0);
    const [collapseAll, setCollapseAll] = useState<boolean>(false);
    const [editFlag, setEditFlag] = useState<boolean>(false);
    const [editField, setEditField] = useState<any>(null);
    const [submodelEditFlag, setSubmodelEditFlag] = useState<boolean>(false);
    const [editSubmodel, setEditSubmodel] = useState<any>(null);
    const [pageEditFlag, setPageEditFlag] = useState<boolean>(false);
    const [editPage, setEditPage] = useState<any>(null);
    const [categoryEditFlag, setCategoryEditFlag] = useState<boolean>(false);
    const [editCategory, setEditCategory] = useState<any>(null);
    const [editCategoryImage, setEditCategoryImage] = useState<any>(null);
    const [searchInput, setSearchInput] = useState("");
    const {fieldUpdate, fieldDelete, industryId} = useContext(ISRContext);
    const [showAttributeModal, setShowAttributeModal] = useState(false);
    const [attributes, setAttributes] = useState<any[]>([]);
    const [loadingAttributes, setLoadingAttributes] = useState<boolean>(false);

    const appData = useContext<any>(AppContext);

    let selectedPartyName = (appData.selectedParty.name.replace(/ /g,"_")).toLowerCase();

    const rootPreviewURL: string = process.env.REACT_APP_ROOT_PREVIEW_URL ?? '';

    const [uiBuilderConfig, setUiBuilderConfig] = useState<any>({
        builderCreated: false,
        builderConfigured: false,
        builderSaved: false,
        customization: {}
    })

    const previewUrl: string = `https://${selectedPartyName}.${rootPreviewURL}/preview?modelId=${ modelId ?? 'xxx'}`

    const defaultFieldTypeMap = new Map([
        [MULTI_CHOICE, 'Checkbox'],
        [TEXT_FIELD, 'Text Field'],
        [FIELD, 'Text Field'],
        [INTEGER, 'Text Field'],
        [DECIMAL, 'Text Field'],
        [BOOLEAN, 'Drop down'],
        [FRACTION, 'Text Field'],
        [RANGE_FIELD, 'Range Field'],
    ]);

    useEffect(() => {
        updateSubmodelFieldFromUi(fieldUpdate);
    }, [fieldUpdate]);

    useEffect(() => {
        let isMounted = true;
        const timerId = setTimeout(() => {
            if (isMounted) {
                deleteSubmodelFieldFromUi(fieldDelete);
            }
        }, 500);
        return () => {
            isMounted = false;
            clearTimeout(timerId);
        };
    }, [fieldDelete]);

    useEffect(()=>{

        let data = Array.isArray(builderData.builderPages) ? builderData.builderPages[0] : builderData.builderPages;
        const builderConfig = builderData.builderPages?.config ? {...builderData.builderPages?.config, builderConfigured: true} : { builderCreated: false, builderConfigured: false, builderSaved: false, customization: {}};
        setUiModelProjectData((prevUiModel) => {
            return{
                ...prevUiModel,
                pages: data?.pages ? data?.pages : [{id: 1, pageName: 'New Page 1', formData: []}],
                config: data?.config ? data?.config : { builderCreated: false, builderConfigured: false, builderSaved: false, customization: {}},
            }
        });
        setUiBuilderConfig(builderConfig)
        setAttributes([])
    }, [projectId]);

    const handleAddButtonClick = () => {
        const newPageName = `New Page ${uiModelProjectData.pages.length + 1}`;
        setUiModelProjectData((prevUiModel: any) => ({ ...prevUiModel, pages: [ ...prevUiModel.pages, { id: uiModelProjectData.pages.length + 1, pageName: newPageName, formData: [], }, ],}));
        setActiveTabIndex(uiModelProjectData.pages.length);
    };

    const handleCollapseAllClick = () => {
        setCollapseAll((prev) => prev = !prev);
    }

    useEffect(() => {
        if (uiModelProjectData?.projectId === '') {
            setUiModelProjectData((prevUiModel) => {            
                const updatedUiModel = { ...prevUiModel };
                updatedUiModel.projectId = projectId;
                return updatedUiModel;
            });
        } 
        
    }, [projectId]);

    useEffect(() => {
        setUiModelProjectData((prevUiModel) => {
            return {
                ...prevUiModel,
                config: uiBuilderConfig,
            };
        });
    }, [uiBuilderConfig])

        // Fetch attributes when component mounts
    useEffect(() => {
        if (editCategory && editCategory.category) {
            fetchAttributes();
        }
    }, [editCategory?.category?.id]);

    useEffect(() => {
        if(editFlag) setEditFlag(false)
        if(submodelEditFlag) setSubmodelEditFlag(false)
        if(pageEditFlag) setPageEditFlag(false)
        if(categoryEditFlag) setCategoryEditFlag(false)
        if(editCategoryImage != null) setEditCategoryImage(null)
        if(showAttributeModal != null) setShowAttributeModal(false)
    }, [activeTabIndex]);

    const fetchAttributes = async () => {
        try {
            setAttributes([])
            setLoadingAttributes(true)
            const category = uiModelProjectData.pages[activeTabIndex].formData[editCategory.modelIndex].items.find((e: any) => e.id === editCategory.category.id);
            if (!category) return;
            if(category.data.categories.data.length <= 0) return;
            const categoryId = category.data.categories.data[0].id;
            const response = await getProductsByCategory(industryId, categoryId);
            if (response && response.done && response.data) {
                setAttributes(response.data.attributes || []);
            }
        } catch (error) {
            console.error('Error fetching attributes:', error);
        } finally {
            setLoadingAttributes(false)
        }
    };

    const handleSaveAttributes = (attributes: SortableAttribute[]) => {
        const sortConfig = editCategory.category.sortConfig ?? {
            defaultSortOptions: [],
            sortableAttributes: [],
            selectedDefaultSortId: 'compatioscore_descending',
        };
        // const sortableAttributes = sortConfig.sortableAttributes ?? [];
        // sortConfig.sortableAttributes = sortableAttributes.concat(attributes);
        sortConfig.defaultSortOptions = [
                {id: 'compatioscore_descending', label: 'Recommended', direction: 'desc'},
                {id: 'price_ascending', label: 'Price (Low to High)', field: 'product_price', direction: 'asc'},
                {id: 'price_descending', label: 'Price (High to Low)', field: 'product_price', direction: 'desc'},
                {id: 'alphabetical_ascending', label: 'Alphabetical (A to Z)', field: 'product_title', direction: 'asc'},
                {id: 'alphabetical_descending', label: 'Alphabetical (Z to A)', field: 'product_title', direction: 'desc'},
            ];
        sortConfig.sortableAttributes = attributes;
        updateCategory({...editCategory.category, sortConfig: sortConfig}, editCategory.categoryIndex, editCategory.modelIndex);
        setShowAttributeModal(false);
    };

    const setBuilderCreated = (flag: boolean) => {
        setUiBuilderConfig((prevBuilderConfig: any) => {
            const updatedBuilderConfig = { ...prevBuilderConfig };
            updatedBuilderConfig.builderCreated = flag;
            return updatedBuilderConfig;
        })
    }

    const setBuilderConfigured = (flag: boolean) => {
        setUiBuilderConfig((prevBuilderConfig: any) => {
            const updatedBuilderConfig = { ...prevBuilderConfig };
            updatedBuilderConfig.builderConfigured = flag;
            return updatedBuilderConfig;
        })
    }

    const setBuilderSaved = (flag: boolean) => {
        setUiBuilderConfig((prevBuilderConfig: any) => {
            const updatedBuilderConfig = { ...prevBuilderConfig };
            updatedBuilderConfig.builderSaved= flag;
            return updatedBuilderConfig;
        })
    }

    const updateConfig = (customize: any) => {
        setUiBuilderConfig((prevBuilderConfig: any) => {
            const updatedBuilderConfig = { ...prevBuilderConfig };
            updatedBuilderConfig.customization = customize;
            return updatedBuilderConfig;
        })
    }

    const updateDataModelLayout = (dataModelIndex: number, layout: string | null, inclusion: string | null, exclusion: string | null, displayName: string | null, hideWhenNoProductsAvailable: boolean | null) => {
        setUiModelProjectData((prevUiModel: any) => {
            const updatedPages = [...prevUiModel.pages];
            const updatedDataModels = [...updatedPages[activeTabIndex].formData];
            if(layout) {
                updatedDataModels[dataModelIndex].config.viewPref = layout;
            }
            if(inclusion) {
                updatedDataModels[dataModelIndex].config.inclusion = inclusion;
            }
            if(exclusion) {
                updatedDataModels[dataModelIndex].config.exclusion = exclusion;
            }
            updatedDataModels[dataModelIndex].config.hideWhenNoProductsAvailable = hideWhenNoProductsAvailable ?? false
            updatedDataModels[dataModelIndex].config.displayName = displayName ?? ''
            updatedPages[activeTabIndex] = { ...updatedPages[activeTabIndex], formData: updatedDataModels };
            return { ...prevUiModel, pages: updatedPages };
        });
    }

    const handleDeletePage = (pageIndex: number) => {
        setUiModelProjectData((prevUiModel) => {
            const updatedPages = [...prevUiModel.pages];
            updatedPages.splice(pageIndex, 1);
            if(updatedPages.length <= 0) {
                const newPageName = `New Page 1`;
                updatedPages.push({ id: uiModelProjectData.pages.length + 1, pageName: newPageName, formData: [], })
                setActiveTabIndex(0);
            } else {
                const newActiveTabIndex = Math.max(0, pageIndex - 1);
                setActiveTabIndex(newActiveTabIndex);
            }
            return {
                ...prevUiModel,
                pages: updatedPages,
            };
        });
    };

    const reorder = (list: any, startIndex: number, endIndex: number) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    const updateSubmodelFieldFromUi = (fields: ModelTField[]) => {
        setUiModelProjectData((prevUiModel: any) => {
            return {
                ...prevUiModel, pages: (prevUiModel.pages ?? []).map((page: any) => ({
                    ...page, formData: (page.formData ?? []).map((formData: any) => ({
                        ...formData, items: formData.items.map((item: any) => {
                            const fieldToBeUpdated = fields.filter((e) => e.id === item.id);
                            if (fieldToBeUpdated.length > 0) {
                                item.name = fieldToBeUpdated[0].name;
                            }
                            return item;
                        })
                    }))
                }))
            };
        });
    };

    const deleteSubmodelFieldFromUi = (fieldDelete: string[]) => {
        setUiModelProjectData((prevUiModel: any) => {
            return ({
                ...prevUiModel, 
                pages: (prevUiModel.pages ?? []).map((page: any) => {
                    return ({
                        ...page, 
                        formData: (page.formData ?? []).map((formData: any) => {
                            // Add this check
                            if (!formData?.items) {
                                return formData;
                            }
                            return ({
                                ...formData,
                                items: (formData.items ?? []).filter((item: any) => {
                                    return item && item.id && !fieldDelete.includes(item.id);
                                })
                            });
                        })
                    });
                })
            });
        });
    };

    const createUiFieldItem = (field: any) => {
        field.fieldInclusion = INCLUSION_DEFAULT
        if (field.type === "Multi-choice") {
            field.multiChoicefieldExcludedOption = MULTI_CHOICE_EXCLUDED_DEFAULT;
        }
        field.fieldExclusion = EXCLUSION_DEFAULT
        field.fieldType = defaultFieldTypeMap.get(field?.type) ?? ''
        field.modelFieldType = field?.type ?? ''
        field.fieldName = field?.name ?? ''
        field.enableCondition = false
        field.isFieldVisible = true
        field.conditionState = ''
        field.fieldTargetSelection = ''
        field.answerTargetSelection = ''
        field.groupLabel = ''
        field.displayName = field?.name ?? ''
        field.placement = 'filter'
        return field
    }

    const createUiCategoryItem = (category: any) => {
        let {compatioScore, maxCount, maxQuantity, minCount, minQuantity, required, transformations, ...dataRest} = category.data;
        category.data = dataRest;
        const categoryName = category?.data?.name
        category.categoryName = categoryName ?? ''
        category.productLabel = 'Add to cart'
        category.groupLabel = ''
        category.isCategoryVisible = true
        category.inclusion = INCLUSION_DEFAULT
        category.exclusion = EXCLUSION_DEFAULT
        category.categorySelectionLabel = categoryName.length > 0 ? `Select ${categoryName}` : ''
        category.hideWhenNoProductsAvailable = false
        return category
    }

    const onDragEnd = (data: any) => {
        try {
            const { draggableId, source, destination, type } = data;

        if (source && destination) {
            if (source.droppableId === "controls_droppable") {
            
                let draggedComponent = JSON.parse(draggableId);
                if (draggedComponent.isWidget && draggedComponent.targetType === 'submodel') {
                    const newFormData = [...uiModelProjectData.pages[activeTabIndex].formData];
                    const widgetItem = {
                        id: `${draggedComponent.type}-${Date.now()}`,
                        type: draggedComponent.type,
                        name: draggedComponent.name,
                        content: '',
                        isEditing: false
                    };

                    let tempIndex = destination?.index;
                    if (newFormData?.length <= tempIndex) {
                        tempIndex = newFormData?.length - 1;
                    }
                
                    if (newFormData[tempIndex] && newFormData[tempIndex].items) {
                        newFormData[tempIndex].items.unshift(widgetItem);
                        
                        uiModelProjectData.pages[activeTabIndex].formData = newFormData;
                        uiModelProjectData = JSON.stringify(uiModelProjectData);
                        uiModelProjectData = JSON.parse(uiModelProjectData);
                        setUiModelProjectData(uiModelProjectData);
                    }
                    return;
                }
            if(draggedComponent.belongsToDataModel === true) {
                try {
                    const formData = uiModelProjectData.pages[activeTabIndex].formData;
                    const subModelFormData = formData[destination.index];
                    if(!draggedComponent.id) {
                        toast.error("Field doesnt have id");
                        return;
                    }
                    if(subModelFormData.smid !== draggedComponent.subModelId) {
                        toast.error("Field doesnt belong to this submodel");
                        return;
                    }
                    let validate = subModelFormData.items.some(function (el: any) {
                        return el.id === draggedComponent.id
                    });
                    if (validate) {
                        toast.info("You've already added this field");
                        return
                    }
                    let {additionalData, answerTargetSelection, belongsToDataModel, conditionState, dataConfiguration, enableCondition, fieldTargetSelection, rules, ...rest} = draggedComponent;
                    subModelFormData.items = [createUiFieldItem(rest), ...subModelFormData.items]
                    formData[destination.index] = subModelFormData;
                    uiModelProjectData.pages[activeTabIndex].formData = formData;
                    uiModelProjectData = JSON.stringify(uiModelProjectData);
                    uiModelProjectData = JSON.parse(uiModelProjectData)
                    setUiModelProjectData(uiModelProjectData)
                } catch {
                    toast.error("Couldnt add the field to submodel, please try again");
                }
                return;
            }
            let subModelData = JSON.parse(draggableId);
            //let _uiModelProjectData = uiModelProjectData
            let formData = uiModelProjectData.pages[activeTabIndex].formData;

            let validate = formData.some(function(el: any){ return el.smid === subModelData.id});
            if(validate) {
                toast.info("You've already added this model");
                return
            }

            const newFormControl = {
              id: formData.length,
              type: 'Submodel',
              items: [...subModelData.data.fields.map((e: any) => {
                  let {additionalData, answerTargetSelection, conditionState, dataConfiguration, enableCondition, fieldTargetSelection, rules, ...rest} = e;
                  return createUiFieldItem(rest);
              }), ...subModelData.data.connectors, ...subModelData.data.productCategories.map((e: any) => {
                  return createUiCategoryItem(e);
              })],
              name: subModelData.data.name,
              smid: subModelData.id,
              config: {
                  displayName: subModelData.data.name ?? '',
                  hideWhenNoProductsAvailable: false,
                  exclusion: EXCLUSION_DEFAULT,
                  inclusion: INCLUSION_DEFAULT,
              }
            };
            const newFormData: any[] = [...formData];
            newFormData.splice(destination.index, 0, newFormControl);
            uiModelProjectData.pages[activeTabIndex].formData = newFormData;
            uiModelProjectData = JSON.stringify(uiModelProjectData);
            uiModelProjectData = JSON.parse(uiModelProjectData)
            //setFormData(newFormData);
            setUiModelProjectData(uiModelProjectData)
        }
        else if (type === "controls" && source.droppableId === "form_droppable") {
            let formData = uiModelProjectData.pages[activeTabIndex].formData
            if (source.index !== destination.index) {
                const newFormData = reorder(
                    formData,
                    source.index,
                    destination.index
                );
                uiModelProjectData.pages[activeTabIndex].formData = newFormData
                uiModelProjectData = JSON.stringify(uiModelProjectData);
                uiModelProjectData = JSON.parse(uiModelProjectData)
                setUiModelProjectData(uiModelProjectData)
            }
        }
        else if(type.includes("form_items") && source.droppableId.includes("form_items-")) {
            const formSmId = source.droppableId.split("form_items-")[1];
            let formData = uiModelProjectData.pages[activeTabIndex].formData;
            const parentId = formData.findIndex((e: any) => e.smid === formSmId);
            
            if(parentId < 0) {
                return;
            }
        
            const newFormDataMap = formData.map((e: any) => e);
            const subItemsForCorrespondingParent = newFormDataMap[parentId];
            const reorderedSubItems = reorder(
                subItemsForCorrespondingParent.items,
                source.index,
                destination.index
            );
        
            let newFormData = [...formData];
            newFormData = newFormData.map(item => {
                if (item.smid === formSmId || item.id === formSmId) {
                    item.items = reorderedSubItems;
                }
                return item;
            });
        
            uiModelProjectData.pages[activeTabIndex].formData = newFormData;
            uiModelProjectData = JSON.stringify(uiModelProjectData);
            uiModelProjectData = JSON.parse(uiModelProjectData);
            setUiModelProjectData(uiModelProjectData);
        }
    }
        } catch (error) {
            console.error("Error in drag and drop handling:", error);
            return;
        }
    }

    const updateField = (uifield: TField, fieldIndex: number, dataModelIndex: number=0) => {
        try{
            setUiModelProjectData((prevUiModel: any) => {
                let updatedPages = [...prevUiModel.pages];
                const updatedDataModels = [...updatedPages[activeTabIndex].formData];
                const dataModelToUpdate = updatedDataModels[dataModelIndex];

                const updatedFields = [...dataModelToUpdate.items];
                updatedFields[fieldIndex] = { ...updatedFields[fieldIndex], ...uifield, };

                const updatedDataModel = { ...dataModelToUpdate, items: updatedFields,};
                updatedDataModels[dataModelIndex] = updatedDataModel;
                updatedPages[activeTabIndex] = { ...updatedPages[activeTabIndex], formData: updatedDataModels };

                //updatedPages = JSON.parse(JSON.stringify(updatedPages))

                return { ...prevUiModel, pages: updatedPages };
            });
        }
        catch(e){
            console.error(e)
        }
    }

    const updateCategory = (uiCategory: TCategory, categoryIndex: number, dataModelIndex: number=0) => {
        try{
            setEditCategory({ category: uiCategory, categoryIndex: categoryIndex, modelIndex: dataModelIndex })
            setUiModelProjectData((prevUiModel: any) => {
                const updatedPages = [...prevUiModel.pages];
                const updatedDataModels = [...updatedPages[activeTabIndex].formData];
                const dataModelToUpdate = updatedDataModels[dataModelIndex];

                const updatedCategories = [...dataModelToUpdate.items];
                updatedCategories[categoryIndex] = { ...updatedCategories[categoryIndex], ...uiCategory, };

                const updatedDataModel = { ...dataModelToUpdate, items: updatedCategories,};
                updatedDataModels[dataModelIndex] = updatedDataModel;
                updatedPages[activeTabIndex] = { ...updatedPages[activeTabIndex], formData: updatedDataModels };
                
                return { ...prevUiModel, pages: updatedPages };
            });
        }
        catch(e){
            console.error(e)
        }
    };

    const handleSearchInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchInput(event.target.value);
    };

    const filteredDataModels = searchInput?
        userProjectDataModels?.project.dataModels
                .filter(submodel =>
                    submodel.data.name.toLowerCase().includes(searchInput.toLowerCase()) ||
                    submodel.data.fields.some(field =>
                        field.name.toLowerCase().includes(searchInput.toLowerCase())
                    ) ||
                    submodel.data.productCategories.some(category =>
                        category.data.name.toLowerCase().includes(searchInput.toLowerCase())
                    ) ||
                    submodel.data.connectors.some(connector =>
                        connector.data.name.toLowerCase().includes(searchInput.toLowerCase())
                    )
                )
                .map(submodel => ({
                    ...submodel,
                    data: {
                        ...submodel.data,
                        fields: submodel.data.fields.filter(field =>
                            field.name.toLowerCase().includes(searchInput.toLowerCase())
                        ),
                        productCategories : submodel.data.productCategories.filter(category =>
                            category.data.name.toLowerCase().includes(searchInput.toLowerCase())
                        ),
                        connectors : submodel.data.connectors.filter(connector =>
                            connector.data.name.toLowerCase().includes(searchInput.toLowerCase())
                        ),
                    },
                }))
        : userProjectDataModels?.project?.dataModels;

    const filteredFields = searchInput?
        userProjectDataModels?.project?.fields
                .filter(field =>
                    field.data.name.toLowerCase().includes(searchInput.toLowerCase())
                )
        : userProjectDataModels?.project?.fields;

    const filteredCategories = searchInput?
        userProjectDataModels?.project?.productCategories
                .filter(category =>
                    category.data.name.toLowerCase().includes(searchInput.toLowerCase())
                )
        : userProjectDataModels?.project?.productCategories;

    const renderBuilder = () => {
        if(uiBuilderConfig === undefined){
            return null;
        }
        else if(!uiBuilderConfig.builderCreated && uiModelProjectData.pages && uiModelProjectData.pages[0].formData.length === 0){
            return(
                <div className="tw-flex tw-flex-col tw-h-full tw-justify-center tw-items-center tw-space-y-4">
                    <div className="tw-w-[124px] tw-h-[124px] tw-bg-zinc-300 tw-rounded-full"></div>
                    <div className="tw-w-[273px] tw-text-center tw-text-slate-900 tw-text-sm tw-font-semibold tw-font-['Noto Sans'] tw-leading-relaxed">Define interface based on the model</div>
                    <div className="tw-w-[88px] tw-h-8 tw-px-[22px] tw-py-2 tw-bg-blue-800 tw-rounded tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex tw-cursor-pointer"
                        onClick={()=>{
                            setBuilderCreated(true)
                        }}
                    >
                        <div className="tw-text-center tw-text-white tw-text-sm tw-leading-tight">Create</div>
                    </div>
                </div>
            )
        }
        else if( !uiBuilderConfig.builderConfigured){
            return <BuilderConfig setBuilderCreated={setBuilderCreated} setBuilderConfigured={setBuilderConfigured} setBuilderSaved={setBuilderSaved} updateConfig={updateConfig} uiConfig={uiBuilderConfig} />
        }
        else{
            const pageLayout = uiModelProjectData.pages[activeTabIndex].pageLayout
            return(
                <div>
                    { editFlag ? <EditField pageLayout={pageLayout} setEditFlag={setEditFlag} field={editField?.field} fieldIndex={editField?.fieldIndex} modelIndex={editField?.modelIndex} updateField={updateField} /> : null }
                    { submodelEditFlag ? <EditSubmodel pageName={uiModelProjectData.pages[activeTabIndex].pageName} setSubmodelEditFlag={setSubmodelEditFlag} submodel={editSubmodel} updateDataModelLayout={updateDataModelLayout} uiConfig={uiBuilderConfig} /> : null }
                    { pageEditFlag ? <EditPage editPage={editPage} setPageEditFlag={setPageEditFlag} onDelete={(itemIndex: number) => handleDeletePage(itemIndex)} activeIndex={activeTabIndex} setActiveIndex={setActiveTabIndex} pageCount={uiModelProjectData?.pages?.length} handleAddButtonClick={handleAddButtonClick} setUiModelProjectData={setUiModelProjectData} /> : null}
                    { categoryEditFlag ? <EditCategory setCategoryEditFlag={setCategoryEditFlag} submodel={uiModelProjectData.pages[activeTabIndex].formData[editCategory?.modelIndex]} category={editCategory?.category} categoryIndex={editCategory?.categoryIndex} modelIndex={editCategory?.modelIndex} updateCategory={updateCategory} setEditCategoryImage={setEditCategoryImage} setShowAttributeModal={setShowAttributeModal} attributes={attributes} loadingAttributes={loadingAttributes} /> : null }
                    {/* <DefineUIInstruction /> */}
                    { (uiModelProjectData.pages.length > 1 || uiModelProjectData.pages[0].formData.length > 0) && 
                    <div>
                        <div>
                            {/*<div className="tw-relative tw-inline-block tw-text-left">
                                <div>
                                    <button type="button" className="tw-inline-flex tw-w-full tw-justify-center tw-gap-x-1.5 tw-rounded-md tw-bg-white tw-px-3 tw-py-2 tw-text-slate-900 tw-text-sm tw-font-semibold tw-font-['Noto Sans'] tw-leading-relaxed" id="menu-button" aria-expanded="true" aria-haspopup="true">
                                    {uiModelProjectData.config.customization.name ? uiModelProjectData.config.customization.name : "Template 1"}
                                    <svg className="tw--mr-1 tw-h-5 tw-w-5 tw-text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                        <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
                                    </svg>
                                    </button>
                                </div>
 
                                <div style={{zIndex: 200}} className="tw-absolute tw-left-0 tw-z-10 tw-mt-2 tw-w-56 tw-origin-top-right tw-rounded-md tw-bg-white tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-5 tw-focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabIndex={-1}>
                                    <div className="py-1" role="none">
                                        <a href="#" className="tw-text-gray-700 tw-block tw-px-4 tw-py-2 tw-text-sm" role="menuitem" tabIndex={-1} id="menu-item-0">{uiModelProjectData.config.customization.name}</a>
                                        <a href="#" className="tw-text-gray-700 tw-block tw-px-4 tw-py-2 tw-text-sm" role="menuitem" tabIndex={-1} id="menu-item-2">Create New</a>
                                    </div>
                                </div> 
                            </div>*/}
                        </div>
                        <div className="overflow-y-auto tw-w-full tw-h-auto tw-flex tw-flex-row-reverse tw-mr-4 tw-justify-start tw-items-center tw-bg-white tw-rounded-tl tw-rounded-tr tw-overflow-x-scroll no-scrollbar" >
                            <button className="tw-text-primary tw-py-4 tw-mr-4 disabled:tw-text-primary-disabled" disabled={!isPreviewAvailable} onClick={() => {
                                //window.open(`https://sb3-test.compatio.ai/?projectId=${ projectId ?? 'xxx'}`, '_blank')!.focus();
                                isPreviewAvailable && window.open(previewUrl, '_blank')!.focus();
                            }}>{'Preview🔗'}</button>
                            <button className="tw-text-primary tw-py-4 tw-mr-4 tw-first-letter:text-5xl" onClick={() => setBuilderConfigured(false)}>{'Configure'}</button>{/**⚙ */}
                        </div>
                         <div className="overflow-y-auto tw-w-full tw-h-auto tw-flex tw-justify-start tw-items-center tw-bg-shades-of-grey-30 tw-rounded-tl tw-rounded-tr tw-overflow-x-scroll no-scrollbar" >
                            {uiModelProjectData?.pages.map((item: any, uiIndex: any) => (
                                <PageItem key={item?.pageName ?? ''} value={item?.pageName ?? ''} pageLabel={item?.pageLabel ?? ''} isAutoAdvancement={item?.isAutoAdvancement ?? false} pageLayout={item?.pageLayout ?? 'Default'} index={uiIndex} activeIndex={activeTabIndex} setActiveIndex={setActiveTabIndex} pageCount={uiModelProjectData?.pages?.length} setEditPage={setEditPage} setPageEditFlag={setPageEditFlag}/>
                            ))}
                            <AddButton onClick={()=>{handleAddButtonClick()}} />
                        </div>
                    </div> }
                    <WorkSpace formData={uiModelProjectData.pages[activeTabIndex].formData} uiModelProjectData={uiModelProjectData} setUiModelProjectData={setUiModelProjectData} activeTabIndex={activeTabIndex} 
                        setEditFlag={setEditFlag} setEditField={setEditField} setSubmodelEditFlag={setSubmodelEditFlag} setEditSubmodel={setEditSubmodel} setCategoryEditFlag={setCategoryEditFlag} setEditCategory={setEditCategory} projectId={projectId}/>
                </div>
            )
        }
    }

    return (
        <React.Fragment>
            <DragDropContext onDragEnd={onDragEnd}>
                <div id={id} className="tw-flex tw-h-[calc(100vh-171px)]">
                    <div
                        className="tw-flex-grow tw-w-[30%] tw-max-h-full tw-py-2.5 tw-pe-2 tw-border-r tw-border-solid tw-border-[#E5E5EA] tw-flex tw-flex-col">
                        <div className='tw-flex tw-items-center tw-justify-between tw-gap-2 tw-mb-2'>
                            <label className='tw-text-[#090A42] tw-font-semibold tw-text-sm'>{DATA_MODEL}</label>
                        </div>

                        <div className='tw-flex tw-items-center tw-justify-between tw-gap-2 tw-mt-2'>
                            <div
                                className='tw-flex tw-flex-grow tw-items-center tw-h-[32px] tw-p-2 tw-gap-3 tw-rounded-[4px] tw-border-[1px] tw-border-[#7676801F] tw-bg-white'>
                                <img src={searchIcon} alt="Search Category"/>
                                <input
                                    id="modelSearch"
                                    type="search"
                                    onChange={handleSearchInputChange}
                                    placeholder="Search"
                                    className='tw-w-full tw-text-[#747593] tw-font-normal focus:tw-outline-none tw-border-0 tw-text-xs tw-block tw-bg-transparent'
                                />
                            </div>
                            <button onClick={handleCollapseAllClick} className="btn-outlined">
                                {collapseAll ? EXPAND_ALL : COLLAPSE_ALL}
                            </button>
                        </div>

                        <div className="tw-flex-1 tw-overflow-y-auto">
                            <Droppable
                                droppableId="controls_droppable"
                                type="controls"
                                isDropDisabled={true}
                            >
                                {(provided, snapshot) => (
                                    <div {...provided.droppableProps} ref={provided.innerRef}>
                                        {filteredDataModels.length > 0 ? filteredDataModels?.map((submodel) =>
                                            <Draggable
                                                key={`control_draggable_${submodel.id}`}
                                                draggableId={`${JSON.stringify(submodel)}`}
                                                index={-1}
                                            >
                                                {(provided, snapshot) => (
                                                    <div ref={provided.innerRef} {...provided.draggableProps}>
                                                        <SubModelItem
                                                            dragHandleProps={provided.dragHandleProps}
                                                            submodel={submodel}
                                                            uiModelProjectData={uiModelProjectData}
                                                            setUiModelProjectData={setUiModelProjectData}
                                                            activeTabIndex={activeTabIndex}
                                                            collapseAll={collapseAll}
                                                        />
                                                    </div>
                                                )}
                                            </Draggable>
                                        ) : null}

                                        {filteredFields.length > 0 ? filteredFields.map((field) =>
                                            <div key={field?.data?.name + field?.type} className='tw-my-2'>
                                                <SubmodleFieldItem
                                                    fieldName={field?.data?.name}
                                                    fieldType={field?.type}
                                                />
                                            </div>
                                        ) : null}

                                        {filteredCategories.length > 0 ? filteredCategories.map((field) =>
                                            <div key={field?.data?.name + field?.type} className='tw-my-2'>
                                                <SubmodleFieldItem
                                                    fieldName={field?.data?.name}
                                                    fieldType={field?.type}
                                                />
                                            </div>
                                        ) : null}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </div>
                        <WidgetSection
                            onWidgetClick={(widget) => {

                            }}
                            onDragHandleClick={(widget) => {


                            }}
                        />
                    </div>

                    <div
                        className="tw-flex-grow tw-w-[70%] tw-max-h-full tw-py-4 tw-px-4 tw-bg-[#fafafc] tw-overflow-y-auto">
                        {renderBuilder()}
                    </div>
                </div>
            </DragDropContext>
            {editCategoryImage != null ? <EditCategoryImageDialog projectId={projectId}
                                                                  onClose={() => setEditCategoryImage(null)}
                                                                  onSubmit={(url) => {
                                                                      editCategoryImage.category.thumbnail = url;
                                                                      updateCategory(editCategoryImage.category, editCategoryImage.categoryIndex, editCategoryImage.modelIndex);
                                                                      setEditCategoryImage(null)
                                                                  }}/> : null}
            {showAttributeModal && attributes.length > 0 && (
                <PopUp
                    title="Add Sort by Attributes"
                    content={
                        <AddAttributesPopup
                            attributes={attributes}
                            existingAttributes={editCategory?.category?.sortConfig?.sortableAttributes ?? []}
                            onClose={() => setShowAttributeModal(false)}
                            onSave={handleSaveAttributes}
                        />
                    }
                />
            )}
        </React.Fragment>
    );
}

export default UIBuilder;